import { Component, HostListener, OnInit } from '@angular/core'
import { FormBuilder } from '@angular/forms'
import { BehaviourSettingServices } from '../../../../../services/BehaviourSetting.services'

@Component({
    selector: 'app-modal-behavior-condition-value',
    templateUrl: './modal-behavior-condition-value.component.html',
    styleUrls: [
        './modal-behavior-condition-value.component.css',
        '../../../../../stagingcss/main-body.component.css',
        '../../../../../stagingcss/lui-select.component.css',
        '../../../../../stagingcss/root-ui-view.component.css',
        '../../../../../stagingcss/main-view.component.css',
    ],
})
export class ModalBehaviorConditionValueComponent implements OnInit {

    option_show: any = 'hidden'
    arrFormSetting: any[] = []
    id: any
    jsonFormSetting: any = {}
    arrSearch: any[] = []
    arrFist: any[] = []

    view: any = 'condition-value'

    selectedCondition: any

    lengthModalCss: any

    top: any = 10
    right: any = 2.5
    bottom: any = 2
    left: any = 5
    width: any = 90
    numberMuti: any = 2
    opacity: any = -0.5

    constructor(private formBuilder: FormBuilder,
                public behaviourSettingServices: BehaviourSettingServices) {
    }

    ngOnInit() {
        this.get()
    }

    @HostListener('document:keydown', ['$event']) handleKeyboardEvent(event: KeyboardEvent) {
        const keyPressed = event.keyCode
        if (keyPressed === 27) {
            // event.preventDefault();
            const showView: any = this.behaviourSettingServices.returnView()
            if (showView != '' && showView == this.view) {
                this.closeModal()
            }
        }
        // else if (keyPressed == 13) {
        //     event.preventDefault();
        // }
    }

    getStyle(index) {
        const tmpIndex: any = index + 1

        // if (this.tabArray != 'timeline') {
        //     tmpIndex = index + 1;
        // } else {
        //     tmpIndex = index + 2;
        // }
        const surplus: any = tmpIndex % 3
        let tmpLeft: any = this.left
        let tmpRight: any = this.right
        let tmpBottom: any = this.bottom
        let tmpTop: any = 0

        tmpLeft = surplus * this.numberMuti
        tmpRight = this.right + surplus * this.numberMuti
        tmpBottom = this.bottom + surplus * this.numberMuti
        tmpTop = surplus * this.numberMuti
        let style: any = {
            'left': '0%',
        }
        if (surplus != 0) {
            style = {
                'left': tmpLeft + '%',
                'top': tmpTop + '%',
            }
            return style
        }
        return style
    }

    getStyleOpacity(index) {
        const surplus: any = index % 3
        let opacity: any = 0.2
        let style: any = {
            'opacity': opacity,
        }
        if (surplus == 2) {
            opacity = 0.1
            style = {
                'opacity': opacity,
            }
            return style
        }
        return style
    }

    get() {
        this.behaviourSettingServices.changeEmittedStatusConditionValue$.subscribe(status => {
            this.lengthModalCss = $('.modal-length').length - 1
            this.selectedCondition = {}
            if (status != null && status['status'] != undefined) {
                this.option_show = status['status']
                this.selectedCondition = status['selected']
                this.arrSearch = status['options']
                this.arrFist = []
                const thi = this
                this.arrSearch.forEach(function(el) {
                    thi.arrFist.push(el)
                })
                const countLevel: any = this.behaviourSettingServices.getLevel()
                if (countLevel != null && countLevel['identify'] != undefined) {
                    this.id = countLevel['identify']
                }
            }
        })
    }

    closeModal() {
        // if (event) {
        //     event.preventDefault();
        // }
        this.option_show = 'hidden'
        const emitStatus: any = {}
        emitStatus['status'] = 'hidden'
        emitStatus['selected'] = {}
        emitStatus['options'] = []
        this.behaviourSettingServices.emitChangeStatusConditionValue(emitStatus)
        const emitView: any = {}
        emitView['view'] = 'detail-form-setting'
        this.behaviourSettingServices.emitChangeView(emitView)
    }

    selectOption(jsonSelected) {
        // if (event) {
        //     event.preventDefault();
        // }
        const emitValue: any = {}
        emitValue['conditionValue'] = jsonSelected
        emitValue['identify'] = this.id
        this.behaviourSettingServices.emitChangeValueConditionValue(emitValue)
        this.closeModal()
    }

    onChangeKey(event) {
        // if (event) {
        //     event.preventDefault();
        // }
        const arrSearchKey: any[] = []
        const value: string = event.target.value

        this.arrFist.forEach(el => {
            const str: string = el['title']
            if (str.search(value) != -1) {
                arrSearchKey.push(el)
            }
        })
        this.arrSearch = arrSearchKey
    }

}



// WEBPACK FOOTER //
// ./src/app/app_manager/modal/setting/behavior/modal-behavior-condition-value/modal-behavior-condition-value.component.ts